/**
 * CPB: 商品未選択（合計0円）のときカート追加を止め、アラートを表示する
 */
(function () {
  'use strict';

  var ALERT_MESSAGE = '商品が選択されていません';
  var MIN_PRICE = 0.01;

  var PRICE_SELECTORS = [
    '.cpb-product-full-price',
    '.cpb-preview-aside .cpb-product-full-price',
    '.cpb-product-actions .cpb-product-price',
    '.cpb-product-price',
  ];

  function parsePrice(text) {
    if (!text) return 0;
    var normalized = String(text).replace(/[^\d.-]/g, '');
    if (!normalized || normalized === '-' || normalized === '.') return 0;
    var value = parseFloat(normalized);
    return isNaN(value) ? 0 : value;
  }

  /** DOM 上の CPB 合計表示から価格を取得 */
  function getPriceFromDom() {
    var prices = [];

    PRICE_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        prices.push(parsePrice(node.textContent));
      });
    });

    if (!prices.length) return 0;
    return Math.max.apply(null, prices);
  }

  function isAddToCartAllowed() {
    return getPriceFromDom() >= MIN_PRICE;
  }

  function showAlert() {
    window.alert(ALERT_MESSAGE);
  }

  function blockEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function onAddToCartClick(event) {
    var btn = event.target.closest('.cpb-add-to-cart-button');
    if (!btn) return;
    if (isAddToCartAllowed()) return;

    blockEvent(event);
    showAlert();
  }

  function onBeforeAddToCart(event) {
    if (isAddToCartAllowed()) return;

    blockEvent(event);
    showAlert();
  }

  document.body.addEventListener('click', onAddToCartClick, true);
  document.body.addEventListener('before-add-to-cart', onBeforeAddToCart, true);
})();
